<template>
    <DxPopup @hidden="onHidden" :visible="showChangePassPop" :show-close-button="true" :show-title="true" title="Change Password" height="auto" width="600" container=".v-application">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical :headerTitle="menuTitle" :useBtnList="useBtnList" :btnKey="useBtnListKey"
                    @btnSave="btnSave">
                    <template v-slot:body>
                        <v-layout column>
                            <v-row dense class="form-layout">
                                <v-col cols="4" class="pr-2 pt-1 formHeader">
                                    <span>Curent Password</span>
                                </v-col>
                                <v-col cols="8" class="pl-2 pt-1 form-border-right">
                                    <v-text-field v-model="currentPasswod" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="show1 ? 'text' : 'password'" dense @click:append="show1 = !show1" />
                                </v-col>
                            </v-row>
                            <v-row dense class="form-layout mt-0">
                                <v-col cols="4" class="pr-2 pt-1 formHeader">
                                    <span>New Password</span>
                                </v-col>
                                <v-col cols="8" class="pl-2 pt-1 form-border-right">
                                    <v-text-field v-model="newPassword" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="show2 ? 'text' : 'password'" dense @click:append="show2 = !show2" />
                                </v-col>
                            </v-row>
                            <v-row dense class="form-layout mt-0">
                                <v-col cols="4" class="pr-2 pt-1 form-border-bottom-left formHeader ">
                                    <span>Confirm Password</span>
                                </v-col>
                                <v-col cols="8" class="pl-2 pt-1  form-border-bottom form-border-right">
                                    <v-text-field v-model="confirmPassword" :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="show3 ? 'text' : 'password'" dense @click:append="show3 = !show3" />
                                </v-col>
                            </v-row>
                            <v-row dense class="form-layout mt-0 form-warning">
                                Password must be uppercase letters + lowercase letters + numbers.<br>
                                Password must be over 10 character.
                            </v-row>
                          <v-snackbar v-model="snackbar" :timeout="timeout" color="error" top>
                            {{ msg }}
                          </v-snackbar>

                        </v-layout>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
     </DxPopup>
</template>

<script>
import ICardVertical from '@/components/common/iCardVertical'
import { DxPopup } from 'devextreme-vue/popup'
import iCardTop from '@/components/common/iCardTop'
import baseview from '@/components/base/baseview'
import { getNoticeList } from '@/api/view/hip/Z/epmsZ000'
import { updatePassword } from '@/api/view/hip/I/epms6000.js'
import { checkPass } from '@/api/common/login'

import notify from "devextreme/ui/notify";


export default {
    name: 'changePassPop',
    mixins: [baseview],
    components: {
        ICardVertical,
        DxPopup
    },
     props: {
        showChangePassPop: {
            type: Boolean,
            default() {
                return false
            }
         },
         userId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            menuTitle: 'Change Password',
            useBtnList: ['btnSave'],
            useBtnListKey: 0,
            currentPasswod: '',
            newPassword: '',
            confirmPassword: '',
            show1: false,
            show2: false,
            show3: false,
            userGrd: this.$store.state.user.userGrd,
            isSave: true,
            snackbar: false,
            msg: '',
            timeout: 2000,
            //  edtNoticeData: '',
            //  edtNoticeConfig: {}
        }
    },
    watch: {
        'showChangePassPop': {
            handler(value, oldValue) {
                if (value) {
                    this.init()
                }
            },
            immediate: true
        }
    },
    computed: {

    },
    methods: {
        init() {
            this.currentPasswod = '',
            this.newPassword = '',
            this.confirmPassword = ''
        },


        async btnSave() {

            this.isSave = true

            if (this.currentPasswod === null || this.currentPasswod === '') {             
              this.snackbar = true
              this.msg = 'Input current password.'
                this.isSave = false
                return;
            }

            if (this.newPassword === null || this.newPassword === '') {                
                this.snackbar = true
                this.msg = 'Input new password.'                
                this.isSave = false
                return;
            }

            if (this.confirmPassword === null || this.confirmPassword === '') {                                
                this.snackbar = true
                this.msg = 'Input confirm password.'
                this.isSave = false
                return;
            }

            if (this.newPassword != this.confirmPassword) {                                
                this.snackbar = true
                this.msg = 'New password is different with confirm password.'
                this.isSave = false
                return;
            }

            if (this.userGrd != "A" && this.newPassword == this.currentPasswod) { 
                this.snackbar = true               
                this.msg = 'New password must be different with old password.'
                this.isSave = false
                return;
            }
            // before 6 character
            if (this.newPassword.length < 10) {                
                this.snackbar = true               
                this.msg = 'Password must be over 10 character.'
                this.isSave = false
                return;
            }


            let firstChar = this.newPassword.substring(0, 1);
            if (!((firstChar >= "A" && firstChar <= "Z") || (firstChar >= "a" && firstChar <= "z"))) {                                
                this.snackbar = true
                this.msg = 'Password must be start with alphabet.'
                this.isSave = false
                return;
            }

            let includeNumber = false;
            let includeSpace = false;
            let includeUppercase = false;
            for (var i = 0; i < this.newPassword.length; i++) {
                let myChar = this.newPassword.substring(i, i + 1);
                if (myChar >= "0" && myChar <= "9") { includeNumber = true; }
                if (myChar == " ") { includeSpace = true; }
                if (myChar >= "A" && myChar <= "Z") { includeUppercase = true; }
            }

            if (!includeNumber) {                                
                this.snackbar = true
                this.msg = 'Password must be contain number.'
                this.isSave = false
                return;
            }

            if (!includeUppercase) {                                
                this.snackbar = true
                this.msg = 'Password must be contain Uppercase Character.'
                this.isSave = false
                return;
            }

            if (includeSpace) {
                this.snackbar = true
                this.msg = 'Password cannot contain space.'            
                this.isSave = false
                return;
            }

                let param01 = {
                    userId: this.userId,
                    userPw: this.currentPasswod,
                    sysId: "HIP"
                }

                //console.log(param01)

                 checkPass(param01).then(res => {
                    console.log(res)
                    if (res.map.msg === 'pw') {                        
                        this.snackbar = true
                        this.msg = 'Current password is wrong!'
                        this.isSave = false
                        return
                    } else if (res.map.msg === 'id') {                        
                        this.snackbar = true
                        this.msg = 'This user ID not exists!'
                        this.isSave = false
                        return
                    }
                 }).finally(() => {
                     if (this.isSave) {

                    let params = {
                        userId: this.userId,
                        currentPassword: this.currentPasswod,
                        newPassword: this.newPassword,
                    }

                    this.openLoading('update password...')
                    updatePassword(params)
                        .then(res => {                            
                            this.snackbar = true
                            this.msg = 'Your password is successfully updated.'
                        })
                        .catch(error => {
                            this.snackbar = true
                            this.msg = 'An error has occured while changing password.<br>nCheck your old password and try again.'                            
                            this.endLoading()
                        })
                        .finally(() => {
                            this.endLoading()
                        })
                }  
                })                                                     
        },
    onHidden(e) {
            this.$emit('update:showChangePassPop', false)
        }
    },
    mounted() {
        this.init()
    }
}
</script>

<style lang="scss" scoped>
.form-layout .col {
    border-width: 1px 0 0 1px;
    border-style: solid;
    border-color: gray;


}

.form-border-right {
    border-width: 1px 1px 0 1px !important;
    border-style: solid !important;
    border-color: gray !important;
}

.form-border-bottom-left {
    border-width: 1px 0px 1px 1px !important;
    border-style: solid !important;
    border-color: gray !important;
}

.form-border-bottom {
    border-width: 1px 1px 1px 1px !important;
    border-style: solid !important;
    border-color: gray !important;
}

.formHeader {
    background-color: rgb(223, 227, 213);
    font-weight: bold;
    // border: 1px solid gray;
    color: black;
    font-size: 9pt;
}

.form-warning {
    font-width: 10px;
    font-family: bold;
    color: blue;
}
</style>